export const FETCH_POSTS: string = "FETCH_POSTS";
export const HANDLE_ERRORS: string = "HANDLE_ERRORS";
